module.exports = __webpack_public_path__ + "img/02-ABC-m.df8e7772.png";